const prefix = 'CommoditySourceSystem';

export enum CommoditySourceSystemField {
  INTERNAL_ID = `${prefix}.internalId`,
  SOURCE_SYSTEM = `${prefix}.sourceSystem`,
  SOURCE_REFERENCE = `${prefix}.sourceReference`,
  IS_PRIMARY = `${prefix}.isPrimary`,
  LINK = `${prefix}.link`,
}
